<template>
  <span>
    {{ text | translate }}
  </span>
</template>

<script>
export default {
  props: ["policy"],
  computed: {
    text() {
      if (!this.policy?.category) {
        return "";
      }
      const category = this.policy.category;
      if (category == "ADMINISTRATIVE") {
        return this.$t("policy-category.administrative");
      }
      if (category == "TECHNICAL") {
        return this.$t("policy-category.technical");
      }
      if (category == "LEGAL") {
        return this.$t("policy-category.legal");
      }
    },
  },
};
</script>

<style></style>
